export const bannerType = [
  { label: 'Casino Banner', value: 'Casino Banner' },
]

export const tableColumnHeaders = [
  { value: 'id', label: 'Id', accessorKey: 'id', Header: 'Id' },
  { value: 'name', label: 'Name', accessorKey: 'name', Header: 'Name' },
  { value: 'view', label: 'Image', accessorKey: 'view', Header: 'View' },
  // { value: 'action', label: 'Action', accessorKey: 'action', Header: 'Action' }
];
